module.exports = __webpack_public_path__ + "img/login_bg.e5b3ab56.png";